import 'codemirror/addon/scroll/simplescrollbars.js'
import 'codemirror/addon/scroll/annotatescrollbar.js'
import 'codemirror/addon/scroll/simplescrollbars.css'
